import React, {useMemo} from "react";
import { Datagrid, FunctionField, ListBase, ListToolbar, Pagination, Resource, TextField } from 'react-admin';
import { Button as MuiButton } from "@mui/material";
import moment from "moment";

import ExportReportToolbar, { BuildExportUrl } from "../../componets/SubscriberManagementReport/ExportReportToolbar";
import FilterReports from "../../componets/SubscriberManagementReport/FilterReports";
import StatsAndGraphVerification from "../../componets/SubscriberManagementReport/VerificationReportCount";
import FilterChips from "../../componets/Ats/SuperAdminInbox/FilterChips";
import { buildDefaultDateFilters } from "../../utils/dateRangePresets";
import { getStatusStyle } from "../../utils/statusStyles";
import { ATS_API_URL } from "../../config";


const AdminVerificationmanagementList = () => {
    const defaultFilters = useMemo(buildDefaultDateFilters, []);
    const buildExportUrl: BuildExportUrl = ({ filterValues, sort, total }) => {
        if (!ATS_API_URL) {
            return '';
        }

        const query: Record<string, string> = {};

        Object.entries(filterValues || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                query[key] = String(value);
            }
        });

        if (sort?.field) {
            query._sort = sort.field;
            query._order = sort.order ?? 'ASC';
        }

        delete query._start;
        delete query._end;
        delete query.page;

        const safeTotal = typeof total === 'number' && total > 0 ? total : 1;
        query._start = '0';
        query._end = String(safeTotal);

        const params = new URLSearchParams(query);
        const queryString = params.toString();
        return `${ATS_API_URL}/admin/exportverificationmanagementreportdv${queryString ? `?${queryString}` : ''}`;
    };

    const MyList = ({ children, filters, actions, ...props }) => (
        <ListBase {...props} perPage={100}>
            <ListToolbar
                filters={filters}
                actions={actions}
            />
            <StatsAndGraphVerification />
            <FilterChips excludeKeys={['app_invitation_type', 'subscriberID', 'rangeto', 'rangefrom']} />
            {children}
            <Pagination rowsPerPageOptions={[100, 200, 300, 400, 500]} />
            <br />
            <br />
            <br />
            <br />
        </ListBase>
    );

    const DataGrid = () => (
        <Datagrid
            bulkActionButtons={false}
            sx={{
                "& .RaDatagrid-rowEven": { backgroundColor: "#F9F9F9" },
                "& .RaDatagrid-expandIcon": { color: "#fff" },
                "& .RaDatagrid-expandIconCell": { backgroundColor: "primary.main" },
                "& .RaDatagrid-headerCell": {
                    fontWeight: "bold",
                    fontSize: 12,
                },
                "& .RaDatagrid-table": {
                    fontSize: 12,
                    tableLayout: "fixed",
                },
                "& .MuiToggleButton-root.Mui-selected": {
                    fontWeight: 700,
                },
            }}
        >
            <TextField source="ApplicationNumber" label={'APP ID'} />
            <FunctionField
                sortBy="AppDate"
                label="Date"
                render={(record) => {
                    const formattedDate = moment.utc(record.AppDate).format('MM/DD/YYYY');
                    return <p>{formattedDate}</p>;
                }}
            />
            <TextField source="SubscriberName" label={"Subscriber"} />
            <TextField source="State" />
            <TextField source="City" />
            <FunctionField
                label={"Status"}
                source="Overall Status"
                render={(record) => (
                    <MuiButton
                        sx={{ width: "100%" }}
                        variant="contained"
                        disableElevation={true}
                        style={getStatusStyle(record["Overall Status"])}
                    >
                        {record["Overall Status"]}
                    </MuiButton>
                )}
            />
        </Datagrid>
    );

    return (
        <>
            <br />
            <br />
            <MyList
                filters={<FilterReports />}
                actions={<ExportReportToolbar buildExportUrl={buildExportUrl} />}
                sort={{ field: "ApplicationNumber", order: "DESC" }}
                filterDefaultValues={defaultFilters}
            >
                <DataGrid />
            </MyList>
        </>
    );
};

const AdminVerificationManagement = () => (
    <Resource name="adminVerificationmgt" list={AdminVerificationmanagementList} />
);

export default AdminVerificationManagement;
